export default {
  // Navegación
  'nav.spreadsheet': 'Hoja de cálculo',
  'nav.categories': 'Categorías',
  'nav.guide': 'Guía',
  'nav.faq': 'FAQ',
  'nav.home': 'Inicio',
  'nav.shopping': 'Guía de compras',
  'nav.cta': 'Comprar ahora',

  // Hero
  'hero.badge': 'Recurso independiente · Guías multilingües · Enfoque en seguridad',
  'hero.h1': 'Hoja de cálculo de USFans — Encuentra, explora y organiza información de USFans',
  'hero.sub': 'Explora recursos de la hoja de cálculo de USFans, guías de creadores, reseñas, información de envío, cupones, guías de almacén y recursos de seguridad — todo en una plataforma rápida y fácil de usar.',
  'hero.ctaPrimary': 'Explorar la hoja de cálculo de USFans',
  'hero.ctaSecondary': 'Leer la guía de USFans',
  'hero.trust': 'Recurso independiente • Contenido actualizado • Guías multilingües • Seguridad',
  'hero.scroll': 'Desplázate para explorar',

  // Desplegable
  'dropdown.label': 'Explorar categorías',
  'dropdown.placeholder': 'Selecciona una categoría…',

  // Categorías
  'categories.title': 'Comprar por categoría',
  'categories.sub': 'Explora las categorías populares de USFans y descubre estilos, todo organizado en un solo lugar. Cada enlace abre la tienda oficial en una pestaña nueva.',
  'categories.hint': 'Cada categoría lleva a la tienda principal de USFans.',
  'categories.view': 'Abrir categoría',

  // Tarjetas de funciones
  'features.title': 'Todo lo que necesitas en un solo lugar',
  'features.sub': 'Un centro de recursos completo de USFans basado en información clara y útil.',
  'features.1.title': 'Hoja de cálculo de USFans',
  'features.1.desc': 'Explora recursos y guías organizados de la hoja de cálculo de USFans.',
  'features.2.title': 'Reseña de USFans',
  'features.2.desc': 'Comprende funciones, usabilidad, envío y consideraciones importantes.',
  'features.3.title': 'Costo de envío de USFans',
  'features.3.desc': 'Aprende cómo funcionan los costos de envío y qué afecta el precio final.',
  'features.4.title': 'Cupón de USFans',
  'features.4.desc': 'Encuentra información sobre cupones, promociones y descuentos.',
  'features.5.title': 'Almacén de USFans',
  'features.5.desc': 'Aprende cómo funcionan el almacenamiento, la inspección y el envío.',
  'features.6.title': '¿USFans es legítimo?',
  'features.6.desc': 'Comprende la legitimidad, seguridad, privacidad y riesgos comunes.',

  // Acerca de
  'about.title': '¿Buscas una mejor forma de explorar la información de USFans?',
  'about.p1': 'Nuestro centro de la hoja de cálculo de USFans reúne guías útiles, recursos de creadores, reseñas, información de envío, explicaciones de almacén, descuentos, comparaciones y consejos de seguridad en un solo recurso.',
  'about.p2': 'Ya sea que investigues USFans por primera vez o busques información específica, comienza por el centro de la hoja de cálculo de USFans.',

  // Guía CTA
  'guide.title': 'Lee nuestra guía de la hoja de cálculo de USFans',
  'guide.sub': 'Una guía completa y original sobre qué es una hoja de cálculo de USFans, cómo funciona, cómo buscar creadores y cómo mantenerte seguro.',
  'guide.cta': 'Leer la guía completa',
  'guide.meta': 'Actualizado · Contenido original · Seguridad',

  // Guías
  'guides.title': 'Explora todas las guías de USFans',
  'guides.sub': 'Una biblioteca completa de guías detalladas sobre la hoja de cálculo, creadores, reseñas, envío, cupones, almacén y seguridad.',

  // FAQ
  'faq.title': 'Preguntas frecuentes',
  'faq.sub': 'Respuestas rápidas sobre el recurso de la hoja de cálculo de USFans.',
  'faq.1.q': '¿Qué es una hoja de cálculo de USFans?',
  'faq.1.a': 'Es un recurso organizado que reúne información de USFans — listas de creadores, categorías, guías y enlaces — en un solo lugar fácil de navegar.',
  'faq.2.q': '¿Este sitio web está afiliado con USFans?',
  'faq.2.a': 'No. USFansLink.rest es un sitio web informativo independiente y no está necesariamente afiliado, respaldado ni operado por USFans.',
  'faq.3.q': '¿Cómo navego por las categorías de USFans?',
  'faq.3.a': 'Usa el menú desplegable o los botones de categoría. Cada uno abre la categoría correspondiente en la tienda principal de USFans.',
  'faq.4.q': '¿Las guías son gratuitas?',
  'faq.4.a': 'Sí, todas las guías y artículos de este sitio son gratuitos y tienen fines informativos.',
  'faq.5.q': '¿Verifican la información?',
  'faq.5.a': 'Buscamos mantener el contenido útil y preciso, pero la información de terceros puede cambiar. Verifica siempre los detalles por tu cuenta.',

  // CTA principal
  'cta.title': '¿Listo para explorar la tienda completa de USFans?',
  'cta.sub': 'Navega por la colección completa, descubre nuevas categorías y compra directamente en el sitio web principal de USFans.',
  'cta.primary': 'Hoja de cálculo de USFans',
  'cta.secondary': 'Comprar ahora',

  // Pie de página
  'footer.tagline': 'Un recurso independiente y multilingüe para explorar la información de USFans.',
  'footer.disclaimer': 'USFansLink.rest es un sitio web informativo independiente y no está necesariamente afiliado, respaldado ni operado por USFans. La información de terceros puede cambiar; verifica los detalles por tu cuenta.',
  'footer.links': 'Enlaces rápidos',
  'footer.copyright': '© 2026 USFansLink.rest. Todos los derechos reservados.',

  // Artículo
  'article.breadcrumb': 'Inicio',
  'article.category': 'Guía',
  'article.shortTitle': 'Guía de la hoja de cálculo de USFans',
  'article.readTime': '8 min de lectura',
  'article.updated': 'Actualizado',
  'article.toc': 'Tabla de contenidos',
  'article.related': 'Guías relacionadas',

  'article.h1': 'Hoja de cálculo de USFans: guía completa de creadores, búsqueda y recursos',
  'article.lead': 'Aprende qué es una hoja de cálculo de USFans, cómo funciona, cómo buscar creadores, organizar información y mantenerte seguro — en una guía completa.',

  'article.s1.title': '¿Qué es una hoja de cálculo de USFans?',
  'article.s1.p1': 'Una hoja de cálculo de USFans es un recurso organizado y compartido que recopila información relacionada con USFans en un formato estructurado y fácil de navegar. Suele reunir listas de creadores, categorías, perfiles, detalles de estado, fechas de actualización y enlaces útiles en una vista similar a una tabla.',
  'article.s1.p2': 'Para muchas personas, la hoja de cálculo actúa como punto de partida central. En lugar de buscar en muchas páginas separadas, los usuarios pueden revisar un diseño organizado para encontrar lo que buscan rápidamente. Es especialmente útil para descubrir nuevos creadores y categorías.',

  'article.s2.title': 'Cómo funciona la hoja de cálculo',
  'article.s2.p1': 'La mayoría de las hojas de cálculo de USFans siguen una estructura sencilla basada en columnas. Un diseño típico incluye columnas para el nombre del creador, la categoría, el enlace del perfil, el estado actual y la fecha de la última actualización. Esta estructura facilita ordenar, filtrar y comparar información de un vistazo.',
  'article.s2.p2': 'Algunas hojas se mantienen manualmente y se actualizan según un calendario, mientras que otras se actualizan con más frecuencia. Como los datos pueden cambiar, siempre es buena idea revisar la fuente y verificar los detalles importantes.',

  'article.s3.title': 'Cómo buscar creadores',
  'article.s3.p1': 'Buscar en una hoja de cálculo de USFans suele empezar por las categorías o filtros. Si buscas un creador específico, usa la función de búsqueda o filtro para reducir los resultados por nombre. Si exploras, navega primero por categoría.',
  'article.s3.p2': 'Un buen enfoque es empezar de forma amplia y luego reducir. Comienza con una categoría que te interese y revisa el estado y la información de actualización para priorizar las entradas activas.',

  'article.s4.title': 'Categorías comunes',
  'article.s4.p1': 'Los recursos de USFans suelen agruparse en categorías para facilitar la navegación. Normalmente incluyen ropa, calzado, accesorios, bolsos, cinturones, fragancias y otros artículos. Agrupar ayuda a comparar opciones similares una al lado de la otra.',
  'article.s4.p2': 'En este sitio, el menú desplegable y los botones de categoría enlazan a la sección correspondiente de la tienda principal, para que puedas pasar de la investigación a navegar productos reales.',

  'article.s5.title': 'Hoja de cálculo vs. directorio vs. búsqueda manual',
  'article.s5.p1': 'Ayuda entender cómo se compara una hoja de cálculo con otras formas de encontrar información. La siguiente tabla resume las principales diferencias.',
  'article.table.c1': 'Aspecto',
  'article.table.c2': 'Hoja de cálculo',
  'article.table.c3': 'Directorio',
  'article.table.c4': 'Búsqueda manual',
  'article.table.r1c1': 'Formato',
  'article.table.r1c2': 'Filas y columnas estructuradas',
  'article.table.r1c3': 'Páginas de listado por categoría',
  'article.table.r1c4': 'Una búsqueda a la vez',
  'article.table.r2c1': 'Ideal para',
  'article.table.r2c2': 'Escanear y comparar',
  'article.table.r2c3': 'Navegar por tema',
  'article.table.r2c4': 'Encontrar un elemento específico',
  'article.table.r3c1': 'Actualidad',
  'article.table.r3c2': 'Depende de las actualizaciones',
  'article.table.r3c3': 'Depende del mantenimiento',
  'article.table.r3c4': 'Siempre en vivo',
  'article.table.r4c1': 'Curva de aprendizaje',
  'article.table.r4c2': 'Baja',
  'article.table.r4c3': 'Muy baja',
  'article.table.r4c4': 'Ninguna',

  'article.s6.title': 'Verificación de datos y seguridad',
  'article.s6.p1': 'Como las hojas de cálculo y directorios de USFans suelen ser mantenidos por la comunidad, la información puede no estar siempre completa o actualizada. Verifica siempre los detalles importantes, como enlaces, precios y disponibilidad, directamente en la tienda oficial.',
  'article.s6.p2': 'Ten cuidado con cualquier enlace que pida información personal o pagos fuera del sitio web oficial. Usa enlaces conocidos y de confianza y nunca compartas tus contraseñas ni datos de cuenta.',

  'article.s7.title': 'Consideraciones de privacidad',
  'article.s7.p1': 'Al navegar por recursos de terceros, ten en cuenta la información que compartes. Evita ingresar datos personales sensibles en páginas desconocidas y usa el sitio oficial para cuentas o compras.',
  'article.s7.p2': 'Este recurso independiente no pide tu información personal para navegar. Si una página solicita datos innecesarios, es mejor cerrarla y volver a la fuente oficial.',

  'article.conclusion.title': 'Reflexiones finales',
  'article.conclusion.p1': 'Una hoja de cálculo de USFans es una forma cómoda de explorar creadores, categorías y recursos en un solo lugar. Funciona mejor junto con la verificación independiente y hábitos de seguridad de sentido común.',
  'article.conclusion.p2': '¿Listo para navegar productos reales? Usa el menú de categorías en la página de inicio o explora la tienda completa de USFans directamente.',

  'article.cta': 'Explorar el recurso completo',
  'article.backHome': 'Volver a la página de inicio',

  // Nombres de categorías
  'cat.shoes': 'Zapatos',
  'cat.hoodies': 'Sudaderas / Suéteres',
  'cat.tshirts': 'Camisetas',
  'cat.jackets': 'Chaquetas',
  'cat.pants': 'Pantalones / Shorts',
  'cat.headwear': 'Sombreros',
  'cat.sets': 'Conjuntos',
  'cat.underwear': 'Ropa interior',
  'cat.jersey': 'Camiseta deportiva',
  'cat.accessories': 'Accesorios',
  'cat.bags': 'Bolsos',
  'cat.belts': 'Cinturones',
  'cat.perfumes': 'Perfumes',
  'cat.other': 'Otras cosas',
};